import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

// const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
//     // Change this to your upload POST address:
//     acceptedFiles: 'image/*,.mp4,.mkv,.avi',
//     addRemoveLinks: true,
//     maxFilesize: 50,
// };


import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RegistryService} from './modules/web/services/registry.service';
import {MagentoCustomerService} from './services/magentocustomer.service';
import {ErrorInterceptor} from './interceptors/ErrorInterceptor';
import {SearchEventsService} from './modules/web/components/search-container/search.service';

import {MatSnackBarModule} from '@angular/material/snack-bar';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import {WINDOW_PROVIDERS} from './services/window-provider';
import {OnlineStatusModule} from 'ngx-online-status';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {MatDialogModule} from '@angular/material/dialog';
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import {ShareIconsModule} from 'ngx-sharebuttons/icons';


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http,
        './assets/i18n/',
        '.json');
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    entryComponents: [],

    imports: [

        MatAutocompleteModule,
        NgxDaterangepickerMd.forRoot(),
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            defaultLanguage: 'ar',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        AppRoutingModule,
        MatSnackBarModule,
        FontAwesomeModule,
        // DropzoneModule,
        MatDialogModule,
        ShareButtonsModule.withConfig({
            debug: true,
        }),
        ShareIconsModule


    ],

    providers: [
        MagentoCustomerService,
        SearchEventsService,
        WINDOW_PROVIDERS,
        // {
        //     provide: DROPZONE_CONFIG,
        //     useValue: DEFAULT_DROPZONE_CONFIG
        // },
        [],

    ],


    bootstrap: [AppComponent],

    exports: [
        FormsModule,
        MatSelectModule,
        // NgxUiLoaderModule,
        // NgxUiLoaderRouterModule,
        NgxDaterangepickerMd,
        BrowserAnimationsModule

    ]
})
export class AppModule {
}
